export const MESSAGE_SUCCESS_ANULAR_PRESENTACCION =
    "La presentación fue anulada.";
export const MESSAGE_FAILED_ANULAR_PRESENTACCION =
    "Hubo un error, por favor intente de nuevo.";
export const MESSAGE_FAILED_TRANSACCIONES_DETALLES =
    "El cierre de lote ya se encuentra incluido en por lo menos en una presentación.";
export const MESSAGE_ERROR_TRANSACCIONES_DETALLES =
    "Hubo un error al incluir la Transacción";
    export const MESSAGE_ERROR_EXCLUIR_TRANSACCIONES_DETALLES =
    "Hubo un error al excluir la Transacción";
export const MESSAGE_ERROR_PRESENTACION = "Hubo un error al guardar la presentación"
//AccionesPresentacion
export const  MESSAGE_VALIDACION_IMPUESTOS = "Existen impuestos sin declarar." 
export const MESSAGE_NO_HAY_TRANSACIONES_SELECCIONADAS = "No hay transacciones seleccionadas"

export const MESSAGE_TRX_FECHA_MAYOR_90_DS = "Recuerde que debe presentar las facturas para transacciones pendientes o no se le abonará la presentación más nueva" 

export const MESSAGE_DIFERENCIA_IMPUESTOS_MF = "Existe diferencia entre el total de impuestos de transacciones vs el total de impuestos en los comprobantes" 

export const MESSAGE_TRX_PRECIO_LITRO_BAJO = "El precio del litro del presente producto es considerablemente inferior al valor actual. Considere refacturar estos litros, antes de presentarlos, ya que de lo contrario su presentación será rechazada."
export const MESSAGE_LOTE_PRECIO_LITRO_BAJO = "El precio del litro de algunos productos es considerablemente inferior al valor actual. Considere refacturar esos litros, antes de presentarlos, ya que de lo contrario su presentación será rechazada."